import { SpinePlayer } from '@slot-nx/core'
import { tableService } from '../domain/table/tableService'

interface Props {
  x: number
  y: number
}

export const Background = (props: Props) => {
  return (
    <>
      <SpinePlayer
        name="background_spine"
        onCreatedSpine={spine => tableService.backgroundSpine = spine}
        playOnLoad={true}
        data="bg.skel"
        atlas="bg.atlas"
        x={props.x}
        y={props.y}
        animationStr="main"
        loop={true}
      />
      <SpinePlayer
        name="zeus_spine"
        onCreatedSpine={spine => tableService.zeusSpine = spine}
        playOnLoad={true}
        data="character.skel"
        atlas="character.atlas"
        x={props.x}
        y={props.y}
        animationStr="loop"
        loop={true}
      />
    </>
  )
}
